export const FACEBOOK = {
  type: 'facebook',
  label: 'Facebook',
  icon: ['fab', 'facebook-f']
};

export const INSTAGRAM = {
  type: 'instagram',
  label: 'Instagram',
  icon: ['fab', 'instagram']
};

export const TWITTER = {
  type: 'twitter',
  label: 'Twitter',
  icon: ['fab', 'twitter']
};

export const YELP = {
  type: 'yelp',
  label: 'Yelp',
  icon: ['fab', 'yelp']
};

export const GOOGLEREVIEWS = {
  type: 'google_reviews',
  label: 'Google Reviews',
  icon: 'comments'
};

export const TRIPADVISOR = {
  type: 'tripadvisor',
  label: 'Tripadvisor',
  icon: ['fab', 'tripadvisor']
};



// WEBPACK FOOTER //
// ./src/constants/SocialMedias.js